function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/document
 */
import DocumentSelection from './documentselection';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
/**
 * Document class creates an abstract layer over the content editable area, contains a tree of view elements and
 * {@link module:engine/view/documentselection~DocumentSelection view selection} associated with this document.
 *
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var Document = /*#__PURE__*/function () {
  /**
   * Creates a Document instance.
   */
  function Document() {
    _classCallCheck(this, Document);

    /**
     * Selection done on this document.
     *
     * @readonly
     * @member {module:engine/view/documentselection~DocumentSelection} module:engine/view/document~Document#selection
     */
    this.selection = new DocumentSelection();
    /**
     * Roots of the view tree. Collection of the {@link module:engine/view/element~Element view elements}.
     *
     * View roots are created as a result of binding between {@link module:engine/view/document~Document#roots} and
     * {@link module:engine/model/document~Document#roots} and this is handled by
     * {@link module:engine/controller/editingcontroller~EditingController}, so to create view root we need to create
     * model root using {@link module:engine/model/document~Document#createRoot}.
     *
     * @readonly
     * @member {module:utils/collection~Collection} module:engine/view/document~Document#roots
     */

    this.roots = new Collection({
      idProperty: 'rootName'
    });
    /**
     * Defines whether document is in read-only mode.
     *
     * When document is read-ony then all roots are read-only as well and caret placed inside this root is hidden.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     */

    this.set('isReadOnly', false);
    /**
     * True if document is focused.
     *
     * This property is updated by the {@link module:engine/view/observer/focusobserver~FocusObserver}.
     * If the {@link module:engine/view/observer/focusobserver~FocusObserver} is disabled this property will not change.
     *
     * @readonly
     * @observable
     * @member {Boolean} module:engine/view/document~Document#isFocused
     */

    this.set('isFocused', false);
    /**
     * True if composition is in progress inside the document.
     *
     * This property is updated by the {@link module:engine/view/observer/compositionobserver~CompositionObserver}.
     * If the {@link module:engine/view/observer/compositionobserver~CompositionObserver} is disabled this property will not change.
     *
     * @readonly
     * @observable
     * @member {Boolean} module:engine/view/document~Document#isComposing
     */

    this.set('isComposing', false);
    /**
     * Post-fixer callbacks registered to the view document.
     *
     * @private
     * @member {Set}
     */

    this._postFixers = new Set();
  }
  /**
   * Gets a {@link module:engine/view/document~Document#roots view root element} with the specified name. If the name is not
   * specific "main" root is returned.
   *
   * @param {String} [name='main'] Name of the root.
   * @returns {module:engine/view/rooteditableelement~RootEditableElement|null} The view root element with the specified name
   * or null when there is no root of given name.
   */


  _createClass(Document, [{
    key: "getRoot",
    value: function getRoot() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
      return this.roots.get(name);
    }
    /**
     * Allows registering post-fixer callbacks. A post-fixers mechanism allows to update the view tree just before it is rendered
     * to the DOM.
     *
     * Post-fixers are executed right after all changes from the outermost change block were applied but
     * before the {@link module:engine/view/view~View#event:render render event} is fired. If a post-fixer callback made
     * a change, it should return `true`. When this happens, all post-fixers are fired again to check if something else should
     * not be fixed in the new document tree state.
     *
     * View post-fixers are useful when you want to apply some fixes whenever the view structure changes. Keep in mind that
     * changes executed in a view post-fixer should not break model-view mapping.
     *
     * The types of changes which should be safe:
     *
     * * adding or removing attribute from elements,
     * * changes inside of {@link module:engine/view/uielement~UIElement UI elements},
     * * {@link module:engine/model/differ~Differ#refreshItem marking some of the model elements to be re-converted}.
     *
     * Try to avoid changes which touch view structure:
     *
     * * you should not add or remove nor wrap or unwrap any view elements,
     * * you should not change the editor data model in a view post-fixer.
     *
     * As a parameter, a post-fixer callback receives a {@link module:engine/view/downcastwriter~DowncastWriter downcast writer}.
     *
     * Typically, a post-fixer will look like this:
     *
     *		editor.editing.view.document.registerPostFixer( writer => {
     *			if ( checkSomeCondition() ) {
     *				writer.doSomething();
     *
     *				// Let other post-fixers know that something changed.
     *				return true;
     *			}
     *		} );
     *
     * Note that nothing happens right after you register a post-fixer (e.g. execute such a code in the console).
     * That is because adding a post-fixer does not execute it.
     * The post-fixer will be executed as soon as any change in the document needs to cause its rendering.
     * If you want to re-render the editor's view after registering the post-fixer then you should do it manually by calling
     * {@link module:engine/view/view~View#forceRender `view.forceRender()`}.
     *
     * If you need to register a callback which is executed when DOM elements are already updated,
     * use {@link module:engine/view/view~View#event:render render event}.
     *
     * @param {Function} postFixer
     */

  }, {
    key: "registerPostFixer",
    value: function registerPostFixer(postFixer) {
      this._postFixers.add(postFixer);
    }
    /**
     * Destroys this instance. Makes sure that all observers are destroyed and listeners removed.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.roots.map(function (root) {
        return root.destroy();
      });
      this.stopListening();
    }
    /**
     * Performs post-fixer loops. Executes post-fixer callbacks as long as none of them has done any changes to the model.
     *
     * @protected
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer
     */

  }, {
    key: "_callPostFixers",
    value: function _callPostFixers(writer) {
      var wasFixed = false;

      do {
        var _iterator = _createForOfIteratorHelper(this._postFixers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            wasFixed = callback(writer);

            if (wasFixed) {
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } while (wasFixed);
    }
    /**
     * Event fired whenever document content layout changes. It is fired whenever content is
     * {@link module:engine/view/view~View#event:render rendered}, but should be also fired by observers in case of
     * other actions which may change layout, for instance when image loads.
     *
     * @event layoutChanged
     */

  }]);

  return Document;
}();

export { Document as default };
mix(Document, ObservableMixin);
/**
 * Enum representing type of the change.
 *
 * Possible values:
 *
 * * `children` - for child list changes,
 * * `attributes` - for element attributes changes,
 * * `text` - for text nodes changes.
 *
 * @typedef {String} module:engine/view/document~ChangeType
 */